// Content Editor functionality for contenteditable areas
window.initializeContentEditor = function initializeContentEditor() {
    const contentEditBoxes = document.querySelectorAll('.content-edit-box');
    
    if (!contentEditBoxes.length) return;
    
    contentEditBoxes.forEach(box => {
        const toolbar = box.querySelector('.content-edit-header');
        const editor = box.querySelector('.content-edit-body');
        
        if (!toolbar || !editor) return;
        
        // Handle toolbar button clicks
        toolbar.addEventListener('click', function(e) {
            const button = e.target.closest('button');
            if (!button) return;
            
            e.preventDefault();
            
            const action = button.getAttribute('data-action');
            const value = button.getAttribute('data-value');
            
            // Focus editor before executing command
            editor.focus();
            
            // Execute the formatting command
            if (action) {
                executeCommand(action, value);
            }
            
            // Save content after editing
            saveEditorContent(editor);
        });
        
        // Load content from hidden textarea if exists
        loadEditorContent(editor);
        
        // Save content on input
        editor.addEventListener('input', function() {
            saveEditorContent(editor);
        });
        
        // Prevent default behavior on paste and clean up content
        editor.addEventListener('paste', function(e) {
            e.preventDefault();
            const text = (e.clipboardData || window.clipboardData).getData('text/plain');
            document.execCommand('insertText', false, text);
        });
    });
    
    // Initialize Bootstrap tooltips with delay for toolbar buttons
    initializeToolbarTooltips();
}

function executeCommand(command, value = null) {
    // Special handling for formatBlock
    if (command === 'formatBlock') {
        // Chrome requires tag name format like '<p>' or '<h5>'
        value = value ? `<${value}>` : '<p>';
    }
    
    try {
        document.execCommand(command, false, value);
    } catch (error) {
        console.error('Error executing command:', command, error);
    }
}

function saveEditorContent(editor) {
    // Get the data-theme-key from nearby textarea
    const model = editor.closest('[data-model]');
    if (!model) return;
    
    const modelName = model.getAttribute('data-model');
    
    // Find the hidden textarea (e.g., eventDetails for event-details-form-tab)
    let targetTextarea = null;
    
    if (modelName.includes('event-details-form')) {
        targetTextarea = document.getElementById('eventDetails');
    }
    
    if (targetTextarea) {
        targetTextarea.value = editor.innerHTML;
        
        // Trigger change event for form data storage
        const event = new Event('change', { bubbles: true });
        targetTextarea.dispatchEvent(event);
        
        // Save to formDataStorage if available
        if (window.formDataStorage && typeof window.formDataStorage.saveFormData === 'function') {
            const themeKey = targetTextarea.getAttribute('data-theme-key');
            if (themeKey) {
                const data = {};
                data[themeKey] = editor.innerHTML;
                window.formDataStorage.saveFormData(data);
            }
        }
    }
}

function loadEditorContent(editor) {
    const model = editor.closest('[data-model]');
    if (!model) return;
    
    const modelName = model.getAttribute('data-model');
    
    // Find the hidden textarea
    let sourceTextarea = null;
    
    if (modelName.includes('event-details-form')) {
        sourceTextarea = document.getElementById('eventDetails');
    }
    
    if (sourceTextarea && sourceTextarea.value) {
        editor.innerHTML = sourceTextarea.value;
    } else if (window.formDataStorage && typeof window.formDataStorage.getStoredData === 'function') {
        // Try to load from formDataStorage
        const storedData = window.formDataStorage.getStoredData();
        if (sourceTextarea) {
            const themeKey = sourceTextarea.getAttribute('data-theme-key');
            if (themeKey && storedData[themeKey]) {
                editor.innerHTML = storedData[themeKey];
                sourceTextarea.value = storedData[themeKey];
            }
        }
    }
}

function initializeToolbarTooltips() {
    const toolbarButtons = document.querySelectorAll('.content-edit-header button[data-bs-toggle="tooltip"]');
    
    if (!toolbarButtons.length) return;
    
    // Initialize tooltips with custom delay
    toolbarButtons.forEach(button => {
        new bootstrap.Tooltip(button, {
            delay: { show: 500, hide: 100 },
            trigger: 'hover'
        });
    });
}

// Auto-initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeContentEditor);
} else {
    // DOM already loaded
    initializeContentEditor();
}

// Also initialize when new modals/forms are opened
document.addEventListener('click', function(e) {
    const targetModel = e.target.closest('[data-target-model]');
    if (targetModel) {
        setTimeout(() => {
            initializeContentEditor();
        }, 100);
    }
});

// Export for module systems
if (typeof module !== 'undefined' && module.exports) {
    module.exports = { initializeContentEditor };
}
